import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {IStatus} from "@/entity/status/status.types";
import {ResponseDataType} from "@/form/form.types";
import {ISalaryScheme} from "@/entity/salaryScheme/salaryScheme.types";

@Module({
    namespaced: true,
    name: 'salary',
    store,
    dynamic: true,
})
class SalaryModule extends VuexModule {
    salary: ISalaryScheme[] = [];
    salaryLoaded = false;

    @MutationAction
    async fetchAll(): Promise<{ salary: ISalaryScheme[]; salaryLoaded: boolean }> {
        const salary = await store.$repository.salaryScheme.fetchAll();
        let salaryLoaded = false;
        if (salary.length > 0) {
            salaryLoaded = true;
        }
        return {salary, salaryLoaded};
    }
}

export const SalaryStore = getModule(SalaryModule);
